module.exports = __webpack_public_path__ + "static/media/live.bef7c48f.png";